<script setup>
import Icon from '@ant-design/icons-vue';
import { defineAsyncComponent, watch } from 'vue';

const props = defineProps({
  iconName: {
    type: String,
    required: true,
  },
  height: {
    type: String,
    default: '1rem',
  },
  width: {
    type: String,
    default: '1rem',
  },
  fill: {
    type: String,
    default: null,
  },
});

let SvgIcon = defineAsyncComponent(function () {
  return import(`@/assets/icons/${props.iconName}.svg`);
});

watch(
  () => props.iconName,
  () => {
    SvgIcon = defineAsyncComponent(function () {
      return import(`@/assets/icons/${props.iconName}.svg`);
    });
  },
);
</script>

<template>
  <Icon>
    <template #component="svgProps">
      <component
        :is="SvgIcon"
        v-bind="svgProps"
        :height="props.height"
        :width="props.width"
        :fill="props.fill || svgProps.fill"
      ></component>
    </template>
  </Icon>
</template>
